module.exports = __webpack_public_path__ + "catalog/items/three-phase-panel/threePhasePanel.png";